import {Bounce} from "react-toastify";
import {isTestMode} from "../../constants/mode";
const CONFIG = {
  position: "top-center",
  autoClose: isTestMode ? false : 5000,
  hideProgressBar: false,
  newestOnTop: true,
  closeOnClick: false,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: false,
  transition: Bounce,
  toastStyle: {
    backgroundColor: "#ffffff",
  },
};

export default CONFIG;
